<template>
  <div class="report-view report-summary-information">
    <div class="report-head">
      <div class="report-num">
        <p>Форма № учёт-1</p>
      </div>
      <h5 class="text-center">Сведения по площади хозяйств и экспликации охотугодий {{ year }} года
        <label v-if="oopt"><u>{{ oopt }}</u>
          <span class="sm-hint">наименование охотпользователя</span>
        </label>
      </h5>
    </div>
    <!-- report-body -->
    <div class="report-body">
      <div class="table-overflow">
        <table class="table-full">
          <thead>
          <tr>
            <td rowspan="2">№ п/п</td>
            <td rowspan="2">Наименование охотхозяйств и егерских участков</td>
            <td :colspan="header.terrainTypes.length + 1">В том числе по типам угодий</td>
          </tr>
          <tr>
            <td>{{ header.area }}</td>
            <template v-for="terrainType in header.terrainTypes">
              <td :key="terrainType.name">
                <span>{{ terrainType.name }}</span>
              </td>
            </template>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, i) in reportData" :key="item.id">
            <td class="td-num">{{ ++i }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.area }}</td>
            <template v-for="terrainType in header.terrainTypes">
              <td :key="'body_'+terrainType.name">
                {{ item.terrainTypes ? item.terrainTypes[terrainType.id] ? item.terrainTypes[terrainType.id].value : '' : '' }}
              </td>
            </template>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="report-footer">
      <div class="report-footer-item">
        <div class="flexbox">
          <div class="mleft-7">
            <p><span>_________________________________</span> <span>_____________________________</span><br><span>Ф.И.О. должность составителя</span> <span>подпись</span></p>
          </div>
          <div class="mleft-7">
            <p><span>дата "_____"__________20___г.</span></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    reportData: Array,
    header: Object,
    year: String,
    oopt: String
  },
  data: () => ({
    tdCount: 0
  })
}
</script>

<style scoped>

</style>
